var t = "__i18nMissingKeys__";
var r = [], y = { missing: r }, l = (e, n) => e.lng === n.lng && e.ns === n.ns && e.key === n.key, o = (e) => (typeof window < "u" && (window[t] = y), (n, i, a) => {
  if (!e.hasLoadedNamespace(i) || r.length >= 200) return;
  const s = {
    lng: n?.[0] ?? e.language,
    ns: i,
    key: a
  };
  r.some((g) => l(g, s)) || r.push(s);
});
export {
  t as GLOBAL_PROPERTY,
  o as installMissingKeyRegistry
};

//# sourceMappingURL=TranslationProvider.missingKeys.js.map